import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MatrizEvaluacionPuestoServices from "./MatrizEvaluacionPuesto.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getMatrizEvaluacionPuesto = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
      payload: true,
    });
    const resp = await MatrizEvaluacionPuestoServices.getMatrizEvaluacionPuesto(
      filters
    );
    dispatch({
      type: actions.GET_MATRIZ_EVALUACION_PUESTO,
      payload: resp.data,
    });
    dispatch({
      type: actions.MATRIZ_EVALUACION_PUESTO_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.MATRIZ_EVALUACION_PUESTO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
      payload: false,
    });
  }
};

export const getModalMatrizEvaluacionByMatrizId = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: true,
    });
    const resp = await MatrizEvaluacionPuestoServices.getMatrizEvaluacionPuesto(
      filters
    );
    let modifiedData = resp.data
    modifiedData.data[0].info_matriz.forEach((item) => {
      item.factores = item.factores.flatMap((factor)=> factor.factores)      
    });    
    dispatch({
      type: actions.GET_MODAL_MATRIZ_EVALUACION,
      payload: modifiedData
    });
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: false,
    });
  }
};

export const getModalMatrizEvaluacion = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: true,
    });
    const resp = await MatrizEvaluacionPuestoServices.getModalMatrizEvaluacion(
      filters
    );
    dispatch({
      type: actions.GET_MODAL_MATRIZ_EVALUACION,
      payload: resp.data,
    });
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: false,
    });
  }
};

export const cleanModalMatrizEvaluacion = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: true,
    });
  
    dispatch({
      type: actions.GET_MODAL_MATRIZ_EVALUACION,
      payload: null,
    });
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.MODAL_MATRIZ_EVALUACION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_MODAL_MATRIZ_EVALUACION,
      payload: false,
    });
  }
};

export const saveMatrizEvaluacionPuesto =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: true,
      });
      debugger
      const resp =  await MatrizEvaluacionPuestoServices.saveMatrizEvaluacionPuesto(req);
      const { matrizEvaluacionPuesto } =  getState().matrizEvaluacionPuesto
      let _matrizEvaluacionPuesto = matrizEvaluacionPuesto
      _matrizEvaluacionPuesto.data = [resp.data.data[0], ...matrizEvaluacionPuesto.data]
      _matrizEvaluacionPuesto.count += 1
      dispatch({
        type: actions.GET_MATRIZ_EVALUACION_PUESTO,
        payload: _matrizEvaluacionPuesto
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      dispatch({
        type: actions.GET_MODAL_MATRIZ_EVALUACION,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: false,
      });
    }
  };

export const editMatrizEvaluacionPuesto =
  (req, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: true,
      });
      const resp =
        await MatrizEvaluacionPuestoServices.editMatrizEvaluacionPuesto(
          id,
          req
        );
      const { matrizEvaluacionPuesto } = getState().matrizEvaluacionPuesto
      let _matrizEvaluacionPuesto = matrizEvaluacionPuesto
      _matrizEvaluacionPuesto.data[index] = resp.data.data[0];
      dispatch({
        type: actions.GET_MATRIZ_EVALUACION_PUESTO,
        payload: _matrizEvaluacionPuesto
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      dispatch({
        type: actions.GET_MODAL_MATRIZ_EVALUACION,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: false,
      });
    }
  };

export const deleteMatrizEvaluacionPuesto =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: true,
      });
      await MatrizEvaluacionPuestoServices.deleteMatrizEvaluacionPuesto(id);
      const { matrizEvaluacionPuesto } =  getState().matrizEvaluacionPuesto
      let _matrizEvaluacionPuesto = matrizEvaluacionPuesto
      _matrizEvaluacionPuesto.data.splice(index, 1);
      _matrizEvaluacionPuesto.count -= 1
      
      dispatch({
        type: actions.GET_MATRIZ_EVALUACION_PUESTO,
        payload: _matrizEvaluacionPuesto
      });
      dispatch({
        type: actions.MATRIZ_EVALUACION_PUESTO_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data[0]) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      dispatch({
        type: actions.LOADING_MATRIZ_EVALUACION_PUESTO,
        payload: false,
      });
    }
  };
